import React from 'react';
import Logo from '../../assets/Logo-light.png';
import { CiLocationOn, CiMail } from 'react-icons/ci';
import { FiPhone } from 'react-icons/fi';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer>
            <div className="bg-[#102343] text-white p-8 py-16 mt-8 flex items-center justify-center">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-10 p-4 max-w-7xl">
                    {/* Left Side - Foundation Info */}
                    <div className='sm:col-span-2'>
                        <img src={Logo} alt="logo" className="w-[180px] mb-6" />
                        <p className="text-[16px] leading-relaxed font-[400]">
                            Through the concept of helping children to help themselves, Iretiola Children’s Foundation wants to give children the opportunity to positively influence society in the future through school education and by raising awareness about ecological and health problems in Nigeria.
                        </p>
                    </div>

                    {/* Middle section - Company Info */}
                    <div className="ml-4 ">
                        {/* <h2 className="text-xl font-bold mb-4">Company</h2> */}
                        <ul className="space-y-2">
                            <li><a href="#aboutUs" className="hover:underline">About Us</a></li>
                            <li><a href="#sponsor" className="hover:underline">Sponsors</a></li>
                            <li><a href="#building" className="hover:underline">Our Buildings</a></li>
                            <li><a href="#" className="hover:underline">Our Projects</a></li>
                            <li><a href="#team" className="hover:underline">Our Team</a></li>
                        </ul>
                    </div>

                    {/* Right side - Company Info */}
                    <div className="ml-0 sm:col-span-2 ">
                        {/* <h2 className="text-xl font-bold mb-4">Company</h2> */}
                        <ul className="space-y-3 footerlink">
                            <li><CiMail size={24} /><a href="#" className="hover:underline">iretiolafoundation.com</a></li>
                            <li><FiPhone size={24} /><a href="#" className="hover:underline">+234 803 678 8561, +234 708 648 5262</a></li>
                            <li><CiLocationOn size={24} /><a href="#" className="hover:underline">36, Banana Street, Sogunro Aba OriOke, Soka Ibadan.</a></li>
                            <li><a href="#"><FaFacebook size={24} /></a> <a href="#team"><FaInstagram size={24} /></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* Social Media Links */}
            <div className="bg-[#102343] text-white p-4 text-start border-t border-t-white">
                <p>© Iretiola Children’s Foundation</p>
            </div>
        </footer>
    );
}

export default Footer;
